import type { SurveyGroup } from 'src/types/survey-group.types';

/**
 * Results URL for a survey group (group id in path; optional `groupSurveys` query for selection).
 */
export function buildSurveyGroupResultsPath(
  group: SurveyGroup,
  clientId: string | undefined
): string {
  if (clientId) {
    return `/client/${clientId}/results/group/${group.id}`;
  }
  return `/results/group/${group.id}`;
}
